'use client';

import { motion } from 'motion/react';

export default function SkeletonLoader() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] px-6 pt-32 md:px-12 lg:px-24">
      <div className="mx-auto max-w-7xl">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-8">
          <div className="flex flex-col justify-center space-y-8">
            <div className="flex gap-4">
              <motion.div
                className="h-8 w-32 rounded-full bg-zinc-800"
                animate={{ opacity: [0.5, 1, 0.5] }}
                transition={{ duration: 1.5, repeat: Infinity }}
              />
              <motion.div
                className="h-8 w-32 rounded-full bg-zinc-800"
                animate={{ opacity: [0.5, 1, 0.5] }}
                transition={{ duration: 1.5, repeat: Infinity, delay: 0.2 }}
              />
            </div>
            <div className="space-y-4">
              <motion.div
                className="h-16 w-full rounded-lg bg-zinc-800"
                animate={{ opacity: [0.5, 1, 0.5] }}
                transition={{ duration: 1.5, repeat: Infinity, delay: 0.1 }}
              />
              <motion.div
                className="h-16 w-4/5 rounded-lg bg-zinc-800"
                animate={{ opacity: [0.5, 1, 0.5] }}
                transition={{ duration: 1.5, repeat: Infinity, delay: 0.2 }}
              />
              <motion.div
                className="h-16 w-3/4 rounded-lg bg-zinc-800"
                animate={{ opacity: [0.5, 1, 0.5] }}
                transition={{ duration: 1.5, repeat: Infinity, delay: 0.3 }}
              />
            </div>
            <motion.div
              className="h-24 w-full rounded-lg bg-zinc-800"
              animate={{ opacity: [0.5, 1, 0.5] }}
              transition={{ duration: 1.5, repeat: Infinity, delay: 0.4 }}
            />
            <div className="flex gap-4">
              <motion.div
                className="h-14 w-40 rounded-lg bg-zinc-800"
                animate={{ opacity: [0.5, 1, 0.5] }}
                transition={{ duration: 1.5, repeat: Infinity, delay: 0.5 }}
              />
              <motion.div
                className="h-14 w-40 rounded-lg bg-zinc-800"
                animate={{ opacity: [0.5, 1, 0.5] }}
                transition={{ duration: 1.5, repeat: Infinity, delay: 0.6 }}
              />
            </div>
          </div>
          <div className="relative hidden lg:block">
            <motion.div
              className="absolute inset-0 rounded-2xl bg-zinc-800"
              animate={{ opacity: [0.5, 1, 0.5] }}
              transition={{ duration: 1.5, repeat: Infinity, delay: 0.7 }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
